import { Routes } from "@angular/router";

export const JOBS_ROUTES: Routes = [
    {
        path: 'jobs',
        title: 'Jobs',
        loadComponent: () => import('./jobs.component').then((e) => e.JobsComponent),
        data: {
            icon: 'work',
            module: 'JOB',
        },
        children: [
            {
                path: 'add',
                title: 'Create Job',
                loadComponent: () => import('./job-add/job-add.component').then((m) => m.JobAddComponent),
            },
            {
                path: ':jobId/edit',
                title: 'Edit Job',
                loadComponent: () => import('./job-edit/job-edit.component').then((m) => m.JobEditComponent),
            },
            {
                path: ':id/add-candidates',
                title: 'Add candidates',
                loadComponent: () => import('../candidates/add-candidates/add-candidates.component').then((m) => m.AddCandidatesComponent),
            },
            {
                path: ':jobId/candidates/:candidateJobMappingId',
                title: 'Candidate Details',
                loadComponent: () => import('./job-view/job-candidates/candidate-job-details/candidate-job-details.component').then((m) => m.CandidateJobDetailsComponent),
            },
            {
                path: ':id',
                title: 'Job View',
                data: {
                    reuse: true,
                },
                loadComponent: () => import('./job-view/job-view.component').then((m) => m.JobViewComponent),
                children: [
                    {
                        path: 'candidates',
                        data: {
                            reuse: true,
                        },
                        loadComponent: () => import('./job-view/job-candidates/job-candidates.component').then((m) => m.JobCandidatesComponent),
                    },
                    {
                        path: 'description',
                        data: {
                            reuse: true,
                        },
                        loadComponent: () => import('./job-view/job-description/job-description.component').then((m) => m.JobDescriptionComponent),
                    },
                    { path: '**', redirectTo: 'candidates' }
                ]
            },
            {
                path: '',
                pathMatch: 'full',
                data: {
                    reuse: true,
                },
                loadComponent: () => import('./job-list/job-list.component').then((m) => m.JobListComponent),
            },
        ]
    }
]